import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getSidebarStatus, getSize, setSidebarStatus, setLanguage, setSize } from '@/utils/cookies'
import { getLocale } from '@/lang'
import store from '@/store'
import { FieldType, SelectItemList, ValueType } from '@/api/types-app'
import { IOrderTypeData } from '@/api/types'

export enum DeviceType {
  Mobile,
  Desktop,
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
  language: string
  size: string
  selectItemList: Array<SelectItemList>
  valueTypeList: Array<ValueType>
  fieldTypeList: Array<FieldType>
  orderTypeList: Array<IOrderTypeData>
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: getSidebarStatus() !== 'closed',
    withoutAnimation: false
  }

  public device = DeviceType.Desktop
  public language = getLocale()
  public size = getSize() || 'medium'
  public selectItemList: Array<SelectItemList> = []
  public valueTypeList: Array<ValueType> = []
  public fieldTypeList: Array<FieldType> = []
  public orderTypeList: Array<IOrderTypeData> = []

  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      setSidebarStatus('opened')
    } else {
      setSidebarStatus('closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device
  }

  @Mutation
  private SET_LANGUAGE(language: string) {
    this.language = language
    setLanguage(this.language)
  }

  @Mutation
  private SET_SIZE(size: string) {
    this.size = size
    setSize(this.size)
  }

  @Mutation
  private SET_SELECT_ITEM_LIST_COLLECTION(collection: Array<SelectItemList>) {
    this.selectItemList = collection
  }

  @Mutation
  private SET_VALUE_TYPE_LIST_COLLECTION(collection: Array<ValueType>) {
    this.valueTypeList = collection
  }

  @Mutation
  private SET_FIELD_TYPE_LIST_COLLECTION(collection: Array<FieldType>) {
    this.fieldTypeList = collection
  }

  @Mutation
  private SET_ORDER_TYPE_LIST_COLLECTION(collection: Array<IOrderTypeData>) {
    this.orderTypeList = collection
  }

  @Action
  public loadSelectItemListCollection(collection: Array<SelectItemList>) {
    this.SET_SELECT_ITEM_LIST_COLLECTION(collection)
  }

  @Action
  public loadValueTypeListCollection(collection: Array<ValueType>) {
    this.SET_VALUE_TYPE_LIST_COLLECTION(collection)
  }

  @Action
  public loadFieldTypeListCollection(collection: Array<FieldType>) {
    this.SET_FIELD_TYPE_LIST_COLLECTION(collection)
  }

  @Action
  public loadOrderTypeListCollection(collection: Array<IOrderTypeData>) {
    this.SET_ORDER_TYPE_LIST_COLLECTION(collection)
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public SetLanguage(language: string) {
    this.SET_LANGUAGE(language)
  }

  @Action
  public SetSize(size: string) {
    this.SET_SIZE(size)
  }
}

export const AppModule = getModule(App)
